// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__container-c1f3b4 {
  height: 64px;
  padding: 0 22px 0 34px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--base-20);
}

.Header__right-block-f5fbd6 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.Header__left-block-e1c605 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.Header__icon-bde394 {
  fill: var(--base-120);
}

.Header__title-ab718f {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  color: var(--base-110);
  margin-inline-start: 27px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/Header/styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  height: 64px;\n  padding: 0 22px 0 34px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--base-20);\n}\n\n.right-block {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.left-block {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  fill: var(--base-120);\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  color: var(--base-110);\n  margin-inline-start: 27px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header__container-c1f3b4`,
	"right-block": `Header__right-block-f5fbd6`,
	"rightBlock": `Header__right-block-f5fbd6`,
	"left-block": `Header__left-block-e1c605`,
	"leftBlock": `Header__left-block-e1c605`,
	"icon": `Header__icon-bde394`,
	"title": `Header__title-ab718f`
};
module.exports = ___CSS_LOADER_EXPORT___;
